import * as React from 'react';

import { cn } from '../../lib/utils';
import { DateTimePicker } from '../TovDateTimePicker/TovDateTimePicker';

export interface InputProps extends React.ComponentProps<'input'> {
  enhancedDateTime?: boolean;
}

function Input({
  className,
  enhancedDateTime = false,
  type,
  ...props
}: InputProps) {
  if (type === 'datetime-local' && enhancedDateTime) {
    return <DateTimePicker className={className} {...props} />;
  }

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'tov:h-9 tov:w-full tov:min-w-0 tov:rounded-md tov:border tov:border-input tov:bg-transparent tov:px-3 tov:py-1 tov:text-base tov:shadow-xs tov:transition-[color,box-shadow] tov:outline-none tov:selection:bg-primary tov:selection:text-primary-foreground tov:file:inline-flex tov:file:h-7 tov:file:border-0 tov:file:bg-transparent tov:file:text-sm tov:file:font-medium tov:file:text-foreground tov:placeholder:text-muted-foreground tov:disabled:pointer-events-none tov:disabled:cursor-not-allowed tov:disabled:bg-muted tov:disabled:text-muted-foreground tov:disabled:opacity-100 tov:md:text-sm tov:dark:bg-input/30',
        'tov:focus-visible:border-ring tov:focus-visible:ring-[3px] tov:focus-visible:ring-ring/50',
        'tov:aria-invalid:border-destructive tov:aria-invalid:ring-destructive/20 tov:dark:aria-invalid:ring-destructive/40',
        className,
      )}
      {...props}
    />
  );
}

function Textarea({
  className,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cn(
        'tov:min-h-20 tov:w-full tov:rounded-md tov:border tov:border-input tov:bg-transparent tov:px-3 tov:py-2 tov:text-sm tov:shadow-xs tov:outline-none tov:placeholder:text-muted-foreground tov:disabled:cursor-not-allowed tov:disabled:bg-muted tov:disabled:text-muted-foreground tov:focus-visible:border-ring tov:focus-visible:ring-[3px] tov:focus-visible:ring-ring/50',
        className,
      )}
      {...props}
    />
  );
}

export { Input, Textarea };
